    <h6 id="title">Choix des éléments</h6>
    <div class="list" *ngIf="potentialComponents && potentialComponents.length > 0">
        <div class="box" *ngFor="let component of potentialComponents" (click)="makeLink(component)">{{component.label}}</div>
    </div>

    <h5 *ngIf="!potentialComponents || potentialComponents.length < 1">Aucun élément éligible</h5>

